'use-strict';

const MIN_SEARCH_LENGTH = 2;

/* @ngInject */
export default function CarSelectController(
  $scope,
  $http,
  $timeout,
  toastService,
) {
  $scope.cars = null;
  $scope.searchResults = null;
  $scope.overlay = false;
  $scope.selectedCar = null;
  $scope.inputRequired = $scope.required === 'true';
  $scope.searchPhrase = '';
  $scope.ready = true;
  $scope.searching = false;

  const directiveInit = () => { };

  $scope.initCar = (car) => {
    $scope.selectedCar = car;
  };

  $scope.placeholder = $scope.placeholder || 'Nach Kennzeichen oder VIN suchen';

  const debounce = (fn, wait = 300) => {
    let timeout;
    return function debounced(...args) {
      const ctx = this;
      if (timeout) $timeout.cancel(timeout);
      timeout = $timeout(() => fn.apply(ctx, args), wait);
    };
  };

  const doSearch = () => {
    const lowerCaseSearchPhrase = $scope.searchPhrase.toLowerCase();
    if (lowerCaseSearchPhrase.length < MIN_SEARCH_LENGTH) {
      $scope.searchResults = null;
      return;
    }

    const filter = $scope.includeSold ? {
      'vehicleData.inventory.state': {
        $in: ['ORDERED', 'STOCK', 'SOLD'],
      },
    } : {
      'vehicleData.inventory.state': {
        $in: ['ORDERED', 'STOCK'],
      },
    };

    const orFilter = {
      $or: [
        { vin: { $regex: lowerCaseSearchPhrase, $options: 'i' } },
        { 'vehicleData.registration.licence': { $regex: lowerCaseSearchPhrase, $options: 'i' } },
      ],
    };
    const combinedFilter = { $and: [filter, orFilter] };
    const query = `?filter=${JSON.stringify(combinedFilter)}`;

    $scope.searching = true;
    $http.get(`${API_URL}/api/vehicles/vehicles${query}`)
      .then((result) => {
        $scope.cars = result.data;
        $scope.searchResults = result.data;
        $scope.searching = false;
      })
      .catch((e) => {
        console.error(e);
        $scope.searching = false;
      });
  };

  $scope.searchCar = debounce(doSearch, 300);

  /**
   * If provided as a param, try to find the provided vin in the data and preselect the car.
   */
  const findSearchInit = () => {
    if ($scope.vinInit !== undefined) {
      const foundCar = $scope.cars.find((c) => c.vin === $scope.vinInit);
      if (foundCar !== undefined) {
        $scope.selectCar(foundCar.id);
      } else {
        toastService.toast('error', 'Das gewählte Fahrzeuge konnte nicht gefunden werden. Ggf. muss der Import manuell angestoßen werden.');
      }
    } else {
      $scope.searchCar();
    }
  };

  $scope.saveCars = (cars) => {
    $scope.cars = cars;
    findSearchInit();
  };

  $scope.deselectItem = () => {
    $scope.fsModel = undefined;
    $scope.selectedCar = null;
  };

  $scope.selectCar = (_id) => {
    $scope.fsModel = _id;
    $scope.selectedCar = $scope.cars.find((c) => c._id === _id);
    $scope.hideOverlay();
  };

  $scope.openOverlay = () => {
    $scope.searchPhrase = '';
    $scope.searchResults = null;
    $scope.overlay = true;
  };

  $scope.hideOverlay = () => {
    $scope.overlay = false;
  };

  directiveInit();
}
